import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import VueHead from "vue-head";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
Vue.use(VueHead);

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
axios.defaults.headers.common["X-Basic-Authorization"] =
  process.env.VUE_APP_X_BASIC_AUTHORIZATION;

//エラーハンドリング
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.log(error.response);
    if (error.response.status === 401) {
      window.localStorage.removeItem("vuex");
      router.push("/");
    }
    return Promise.reject(error);
  }
);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
